import React, { useEffect, useState } from "react";

const PaginationBar = (props) => {
  const { config } = props;
//   console.log("Config:", JSON.stringify(config))
  const { count, page, setPage, limit, setLimit } = config;
  
  const [totalPages, setTotalPages] = useState(0);
  
  const [isPrevPageDisabled, setIsPrevPageDisabled] = useState(true);
  const [isNextPageDisabled, setIsNextPageDisabled] = useState(true);

  
  useEffect(() => {
    console.log("useEffect for PaginationBar for count, limit=>", count, limit)
    let totalPages1 = Math.ceil(count/limit);
    setTotalPages(totalPages1);
  }, [count, limit]);

  useEffect(() => {
    console.log("useEffect for PaginationBar page, totalPages=>", page, totalPages)
    if(page == 0){
        setIsPrevPageDisabled(true);
    }else{
        setIsPrevPageDisabled(false);
    }
    
    if(page + 1 == totalPages){
        setIsNextPageDisabled(true);
    }else{
        setIsNextPageDisabled(false)
    }
  }, [page, totalPages]);

  const buttonCss = "disabled:opacity-30 s23-extra-step lg:text-[18x] py-[10px] flex items-center justify-center gap-[5px] md:text-[16px] text-[12px] bg-[#07457F] text-[white] px-[10px] cursor-pointer";
  return (
    <>
      {/* pagination */}
      <div className="flex items-center justify-end mt-1 gap-2">
        <button
          onClick={() => {
            setPage((prev) => prev - 1);
          }}
          disabled={isPrevPageDisabled}
          className={`${buttonCss} rounded-l-[10px]`}
        >
          {"<"}
        </button>
        <button
          onClick={() => {
            setPage((prev) => prev + 1);
          }}
          disabled={isNextPageDisabled}
          className={`${buttonCss} rounded-r-[10px]`}
        >
          {">"}
        </button>

        <span className="flex items-center gap-1">
          <div>Page</div>
          <strong>
            {page + 1} of{" "} {totalPages}
          </strong>
        </span>
        <span className="flex items-center gap-1">
          | Go to page:
          <input
            type="number"
            onKeyDown={(e) => {
              if(e.key === "Enter") {
                let value = e.target.value ? Math.round(e.target.value) : 0;
                let value1 = (value - 1 < 0) ? 0 : value - 1; // for lower values
                let value2 = (value1  >= totalPages - 1) ? totalPages - 1: value1; // for upper values
                setPage(value2);
                e.target.value = "";
              }
            }}
            className="border p-1 rounded w-16 bg-transparent"
          />
        </span>
        <select
          value={limit}
          onChange={(e) => {
            setLimit(Number(e.target.value));
            setPage(0);
          }}
          className="p-2 bg-transparent"
        >
          {[10, 20, 30, 50].map((limit1) => (
            <option key={limit1} value={limit1}>
              Show {limit1}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default PaginationBar;